module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-regular.9dce7f01.eot";